// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__Fj8oG","overlay":"Hero_overlay__OPabS","herotext":"Hero_herotext__IGwP9","icon1":"Hero_icon1__bUa7A"};